<template>
  <div>
    <vue-headful title="Privacyverklaring" />
    <Header page_title="Privacyverklaring" />
    <div class="">
      <div class="container-fluid pb-1 mb-2">
        <div class="text-14" v-if="cms" v-html="cms.content">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      cms: null
    };
  },
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    async fetchData() {
      this.cms = await this.getAPIList("cms/privacy");
    }
  }
};
</script>

<style scoped>
/deep/.list-group .list-group-item {
  position: relative;
}

/deep/.list-group .list-group-item::before {
  content: '';
  position: absolute;
  top: 22px;
  left: 10px;
  display: block;
  width: 5px;
  height: 5px;
  border-radius: 100%;
  background-color: #FFCD00;
}
</style>
